import { useSyncExternalStore } from 'react';
import { getSnapshot, subscribe } from './queue';

/**
 * 订阅队列状态。
 *
 * 用 useSyncExternalStore 而不是 useState + useEffect：队列是模块级单例，
 * 多个组件（状态条、首页、我的页）同时订阅时不会各自持有一份不同步的副本。
 */
export function useUploadQueue() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
